import React from 'react'
import styles from './FJMediaItemPlaceholder.module.less'

function FJMediaItemPlaceholder(props) {
  const {width, height} = props;
  let style = {};
  if (width) {
    style.width = width;
  }
  if (height) {
    style.height = height;
  }
  return (
    <div className={styles.placeholder} style={style}>
      <div style={style}/>
    </div>
  );
}

export default FJMediaItemPlaceholder;